import React from "react";
import { Box } from "@mui/material";

export type PageContainerProps = {
  children: React.ReactNode;
};

const PageContainer: React.FC<PageContainerProps> = ({ children }) => {
  return <Box sx={{ p: 2, width: "100%" }}>{children}</Box>;
};

export default PageContainer;
